import { MAutocomplete, ResponsiveFormContainer } from "@app/components";
import { useIsotopos } from "@services/servicesGenericsTables";
import React from "react";
import { useFormContext } from "react-hook-form";

const TrazadoresForm = () => {
  const { getValues } = useFormContext();
  const { isotoposList } = useIsotopos();

  return (
    <>
      <ResponsiveFormContainer columns={4}>
        <MAutocomplete
          key={JSON.stringify(getValues("isotopo"))}
          name="isotopo"
          options={isotoposList}
          label="Isotopo"
          getOptionLabel={(option) => `${option.codigo}`}
          validation={{ required: "El código es requerido" }}
        />
        <MAutocomplete
          key={JSON.stringify(getValues("trazador"))}
          name="trazador"
          options={isotoposList}
          label="Trazador"
          getOptionLabel={(option) => `${option.codigo}`}
          validation={{ required: "El razador es requerido" }}
        />
      </ResponsiveFormContainer>
    </>
  );
};

export default TrazadoresForm;
